import { FC } from 'react';
import { EventDetailsSummaryProps } from './EventDetailsSummary.types';
import { StyledEventDetailsSummary } from './EventDetailsSummary.styles';
import { DayDetails, EventSpaceInfo } from '../../../EventDetails/EventDetails.types';
import { SummaryRow } from '../../../../molecules';
import { useRfpStore } from '../../../../store';
import { getFormattedDateString } from '../../../../utils';

export const EventDetailsSummary: FC<EventDetailsSummaryProps> = ({ labels }) => {
  const {
    guestRoomsLabel,
    singleBedLabel,
    twinBedLabel,
    suiteLabel,
    totalLabel,
    eventTimeLabel,
    eventSpaceLabel,
    attendeesSuffixText,
    setupStyleLabel,
  } = labels;

  const { eventDetailsData, getEventSpaceConfiguration } = useRfpStore();

  const EventDay = ({ eventDay }: { eventDay: DayDetails }) => {
    return (
      <div className="mb-2">
        <div className="t-subtitle-m">{getFormattedDateString(eventDay.date, 'dateWithDayMonthAndYear')}</div>
        <SummaryRow
          value={
            <>
              {eventDay.singleBedCount && <span>{`${eventDay.singleBedCount} (${singleBedLabel}), `}</span>}
              {eventDay.twinBedCount && <span>{`${eventDay.twinBedCount} (${twinBedLabel}), `}</span>}
              {eventDay.suiteCount && <span>{`${eventDay.suiteCount} (${suiteLabel}), `}</span>}
              <span>{`${eventDay.totalCount} ${totalLabel}`}</span>
            </>
          }
        />
      </div>
    );
  };

  const EventSpace = ({ eventSpace }: { eventSpace: EventSpaceInfo }) => {
    return (
      <div className="mb-2">
        <div className="t-subtitle-m">{getFormattedDateString(eventSpace.date, 'dateWithDayMonthAndYear')}</div>
        {eventSpace.eventList.map(event => (
          <div className="mb-2">
            <SummaryRow label={eventTimeLabel} value={`${event.time[0]} - ${event.time[1]}`} />
            {event.attendees && <SummaryRow value={`${event.attendees} ${attendeesSuffixText}`} />}
            {event.amenities.length ? (
              <SummaryRow
                value={
                  <>
                    <span>{event.amenities[0]}</span>
                    {event.amenities?.[1] && <span>{`, ${event.amenities[1]}`}</span>}
                  </>
                }
              />
            ) : null}
            <SummaryRow label={setupStyleLabel} value={getEventSpaceConfiguration(event.configuration)} />
          </div>
        ))}
      </div>
    );
  };

  return (
    <StyledEventDetailsSummary>
      {eventDetailsData.days.length > 0 ? (
        <div className="mb-4">
          <div className="t-subtitle-m mb-2">{guestRoomsLabel}</div>
          {eventDetailsData.days.map(eventDay => (
            <EventDay eventDay={eventDay} />
          ))}
        </div>
      ) : null}
      {eventDetailsData.eventSpaces.length > 0 ? (
        <>
          <div className="t-subtitle-m mb-2">{eventSpaceLabel}</div>
          {eventDetailsData.eventSpaces.map(eventSpace => (
            <EventSpace eventSpace={eventSpace} />
          ))}
        </>
      ) : null}
    </StyledEventDetailsSummary>
  );
};
